import * as React from 'react';

import { useCountdown } from '@crehana/react-hooks';

const Countdown: React.FC<
  React.PropsWithChildren<{
    dueDate: Date;
    className?: string;
  }>
> = ({ dueDate, className }) => {
  const { rawDays, hours, minutes, seconds, hasStarted, finished } =
    useCountdown(dueDate);

  // biome-ignore lint/style/useBlockStatements: legacy code - style/useBlockStatements
  if (!hasStarted || finished) return null;

  return (
    <React.Fragment>
      <div
        id="countdown-3"
        className={`w-full sm:w-auto rounded-5 flex items-center justify-center font-h4 text-white ${className}`}
      >
        {rawDays > 0 && (
          <>
            <div className="flex flex-col items-center w-40">
              <div>{rawDays < 10 ? `0${rawDays}` : rawDays}</div>
              <div className="font-caption">{rawDays > 1 ? 'Días' : 'Día'}</div>
            </div>
            <div className="mx-8 h-36">.</div>
          </>
        )}
        <div className="flex flex-col items-center w-40">
          <div>{hours}</div>
          <div className="font-caption">
            {parseInt(hours, 10) > 1 ? 'Horas' : 'Hora'}
          </div>
        </div>
        <div className="mx-8 h-36">.</div>
        <div className="flex flex-col items-center w-40">
          <div>{minutes}</div>
          <div className="font-caption">
            {parseInt(minutes, 10) > 1 ? 'Mins' : 'Min'}
          </div>
        </div>
        <div className="mx-8 h-36">.</div>
        <div className="flex flex-col items-center w-40">
          <div>{seconds}</div>
          <div className="font-caption">
            {parseInt(seconds, 10) > 1 ? 'Segs' : 'Seg'}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Countdown;
